

<template>

	<div class="w-full flex justify-center">

		<div v-if="newCollectionModalOpen">
			<AddNewCollection  @close="newCollectionModalOpen = false;" :auth="props.auth"></AddNewCollection>
		</div>


		<!-- Process Pending Slides -->
		<div v-if="props.pendingSlideCount > 0" @click="$emit('openProcessPending')" data-heap="click-process-pending-slides" class="bg-gradient-to-br from-indigo-600 to-indigo-800 rounded-full border border-indigo-600 shadow-xl flex items-center mr-6 cursor-pointer">
			<div class="mx-2 flex">
				<span class="ml-1">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-8" viewBox="0 0 192 192">
						<path fill="none" d="M0 0h192v192H0z"/>
						<path fill="#F29900" d="m116 8 44 44-22 4-22-4-4-20z"/>
						<path fill="#FBBC04" d="M116 52V8H44c-6.63 0-12 5.37-12 12v152c0 6.63 5.37 12 12 12h104c6.63 0 12-5.37 12-12V52h-44z"/>
						<path fill="#FFF" d="M56 76v54h80V76H56zm70 44H66V86h60v34z"/>
					</svg>
				</span>
			</div>
			<span class="bg-indigo-200 mr-2 px-2 py-1 rounded-xl text-indigo-800 text-xs">{{ props.pendingSlideCount }}</span>
			<div class="pr-6 text-left">
				<div class="text-sm text-white">Slides awaiting processing</div>
				<div class="text-xs text-gray-200">Click to review and save</div>
				<!--				<div class="text-lg font-googleBold leading-4 text-gray-900">Please Reauthenticate</div>-->
			</div>
		</div>
		<!-- End Process Pending Slides -->


		<!-- Collection pill -->
		<Listbox as="div" class="flex-shrink-0" v-slot="{ open }">
			<div class="relative">
				<ListboxButton data-heap="change-collection-from-collection">
					<div class="bg-white rounded-full border border-gray-200 shadow-xl mr-6">
						<div class="flex justify-between items-center m-2">

							<div class="pl-1">
								<img :src="'https://www.google.com/s2/favicons?domain=' + props.currentCollection.team.domain + '&sz=128'" class="h-7 m-2" >
							</div>

							<div class="pr-6 text-left">
								<div class="text-xs text-gray-500">Collection</div>
								<div class="text-lg font-googleBold leading-4 text-gray-900">{{ props.currentCollection.name }}</div>
							</div>


							<div class="bg-gray-100 border border-gray-200 h-8 leading-8 m-2 ml-3 rounded-full shadow text-center text-gray-300 px-3">
								{{ props.currentCollection.slides_count }} slides
							</div>

							<div class="mr-4 text-gray-500">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
									<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
								</svg>
							</div>

						</div>
					</div>

				</ListboxButton>

				<transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
					<ListboxOptions v-show="open" class="absolute right-10 z-20 mt-1 min-w-52 bg-white shadow rounded-lg pt-3 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
						<ListboxOption static as="template" v-for="collection in props.collections" :key="collection.short_name" :value=collection v-slot="{ active,selected }">
							<li :class="[active ? 'bg-gray-100' : 'bg-white', 'cursor-pointer select-none relative py-2 px-3']">
								<a :href="collection.short_name" class="flex items-center">
									<span class="flex font-medium truncate">
										{{ collection.name }} <span class="bg-gray-100 rounded-xl ml-2 mr-6 text-xs py-1 px-2 text-gray-800">{{collection.slides_count}} slides</span>
									</span>
									<span
										v-if="collection.short_name === props.currentCollection.short_name"
										class="absolute inset-y-0 right-0 flex items-center pr-3">
										<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
											<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
										</svg>
									</span>
								</a>
							</li>
						</ListboxOption>


						<ListboxOption static as="div" class="flex items-center border-t px-3 py-3 cursor-pointer bg-gray-100 hover:bg-gray-200 group" @click="newCollectionModalOpen = true">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 mr-2 text-gray-500 group-hover:text-indigo-600">
								<path fill-rule="evenodd" d="M3.75 3A1.75 1.75 0 0 0 2 4.75v10.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0 0 18 15.25v-8.5A1.75 1.75 0 0 0 16.25 5h-4.836a.25.25 0 0 1-.177-.073L9.823 3.513A1.75 1.75 0 0 0 8.586 3H3.75ZM10 8a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 10 8Z" clip-rule="evenodd" />
							</svg>

							Create New Collection
						</ListboxOption>


<!--						<div class="flex mr-2 h-[36px]">-->
<!--							<input type="text" name="title" id="labelname"-->
<!--								   class="block w-full border-0 text-sm font-medium placeholder-gray-500 focus:ring-0"-->
<!--								   :class="[newCollectionDuplicateWarning ? 'text-red-500' : '']"-->
<!--								   :disabled="newCollectionDuplicateWarning"-->
<!--								   placeholder="Add new collection..."-->
<!--								   v-model="form.newCollectionName"-->
<!--								   @keydown.space.stop-->
<!--								   @keydown.enter.prevent="addCollection()"-->
<!--							/>-->
<!--							<button v-if="form.newCollectionName.length > 0" @click="addCollection()" class="border border-gray-300 hover:bg-gray-100 hover:cursor-pointer m-1 p-2 rounded shadow">-->
<!--								<svg class="h-3 fill-gray-600" viewBox="-148.269 -27.249 512 377.175" xmlns="http://www.w3.org/2000/svg"><path d="M310.1313-27.249v184.975h-355.2l96.1-98.4-37.8-38.6-161.5 164.6 161.5 164.6 37.8-38.6-96.1-98.4h408.8V-27.249z"/></svg>-->
<!--							</button>-->
<!--						</div>-->

					</ListboxOptions>

				</transition>
			</div>
		</Listbox>
		<!-- END Collection Pill -->


		<!-- Search and tags pill -->
		<div class="bg-white rounded-full border border-gray-200 shadow-xl transition-all duration-500 "
		:class="[selectedTags.length >1 ? 'w-1/2' : 'w-1/3']">
			<div class="flex justify-between items-center h-full">

				<!-- Search -->
				<div class="relative w-full">
					<div class="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">

						<svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd"
								  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
								  clip-rule="evenodd"></path>
						</svg>
					</div>
					<input data-heap="search-slide-title"
						   type="text"
						   name="searchQuery" id="searchQuery"
						   v-model="searchQuery"
						   class="block w-full pl-12 sm:text-sm focus:ring-0 border-0 bg-transparent"
						   placeholder="Search title...">

				</div>

				<!-- Tags -->
				<div class="flex">
					<span>
						<span v-for="(tag,index) in selectedTags" :key=index @click="selectTag(tag)" data-heap="remove-searched-tag"
							  class=" border border-indigo-600 font-medium hover:opacity-100 items-center my-2 mx-0.5 px-2 py-1 relative rounded-full text-xs whitespace-nowrap cursor-pointer"
							  :class="[selectedTags.includes(tag) ? 'bg-indigo-600 opacity-100 text-white hover:bg-indigo-700 drop-shadow-md' : 'bg-indigo-100 opacity-75 text-indigo-900 hover:bg-indigo-200']"
						>
							<span class="font-googleBold">{{ tag }}</span>
						</span>
					</span>


					<Popover class="relative">
						<PopoverButton data-heap="add-search-tag">
							<div>

								<span class="border border-gray-200 hover:border-indigo-400 font-medium hover:opacity-100 items-center mx-3 px-2 py-1 relative rounded-full text-xs whitespace-nowrap cursor-pointer bg-gray-100 opacity-75 text-gray-400 hover:bg-indigo-200 hover:text-indigo-500">
									<span v-if="selectedTags.length === 0" class="font-googleBold mr-1">Add tag</span>
									<span class="font-black font-googleBold p-[0.15rem] rounded-2xl">+</span>
								</span>


							</div>
						</PopoverButton>

						<transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
							<PopoverPanel class="absolute -right-2 z-10 mt-8 flex w-screen max-w-max px-4">
								<div class="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
									<div class="p-4 flex flex-wrap">
										<span v-for="(tag,index) in props.tags" :key=index @click="selectTag(tag.name)"
											  class=" border border-indigo-600 font-medium hover:opacity-100 items-center my-2 mx-2 px-2 py-1 relative rounded-full text-xs whitespace-nowrap cursor-pointer"
											  :class="[selectedTags.includes(tag.name) ? 'bg-indigo-600 opacity-100 text-white hover:bg-indigo-700 drop-shadow-md' : 'bg-indigo-100 opacity-75 text-indigo-900 hover:bg-indigo-200']"
										>
											<span class="font-googleBold">{{ tag.name }}</span>
											<span class="bg-indigo-200 font-black font-googleBold p-[0.15rem] ml-1 rounded-2xl"
												  :class="[selectedTags.includes(tag.name) ? 'bg-indigo-800' : 'bg-indigo-200']"
											>{{tag.slides_count}}</span>
										</span>
									</div>


									<div class="grid grid-cols-2 divide-x border-t bg-gray-50" >
										<div data-heap="clearall-selected-tags" @click="selectedTags = []" class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100 cursor-pointer">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
												<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
											</svg>
											Clear selected tags
										</div>
										<div data-heap="toggle-tag-operator" @click="tagMatchAsOR = !tagMatchAsOR" class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100 cursor-pointer">
											Toggle tag operator <span class="bg-gray-200 p-1 rounded-2xl text-xs">{{ tagMatchAsOR ? 'OR' : 'AND' }}</span>
										</div>
									</div>


								</div>

							</PopoverPanel>
						</transition>
					</Popover>
				</div>
			</div>
		</div>
		<!-- END Search and Tags Pill -->


		<!-- Slider/ settings pill -->
		<div class="bg-white rounded-full border border-gray-200 shadow-xl ml-6 flex items-center">
			<div>
				<div class="text-xs text-gray-500 text-center mb-1">Slide Preview Size</div>
				<input data-heap="change-slide-preview-size" type="range" class="bg-transparent focus:outline-none focus:ring-0 focus:shadow-none h-6 mx-2 w-32" min="5" max="50" id="customRange2" v-model="chartSizing" @input="saveToLocalStorage"/>
			</div>
		</div>
		<!-- END Slider/ settings pill -->

		<!-- GAuth Status Warning -->
		<a data-heap="reauth-from-settings-card" v-if="!authValid" href="/start-google-auth" class="bg-white rounded-full border border-red-500 shadow-xl ml-6 flex items-center">
			<div class="rounded-full bg-white p-2 mx-2 border border-gray-200 shadow">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/><path fill="none" d="M1 1h22v22H1z"/></svg>
			</div>
			<div class="pr-6 text-left">
				<div class="text-sm text-red-600">Google Auth Expired</div>
				<div class="text-xs text-gray-500">Click to reauthenticate</div>
<!--				<div class="text-lg font-googleBold leading-4 text-gray-900">Please Reauthenticate</div>-->
			</div>
		</a>
		<!-- End GAuth Status Warning -->

	</div>

</template>

<script setup>

import {
	Listbox,
	ListboxButton,
	ListboxOption,
	ListboxOptions,
	Popover,
	PopoverButton,
	PopoverPanel,
	Switch
} from "@headlessui/vue";
import {onMounted, ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import AddNewCollection from "@/Pages/SlideRepo/Modals/AddNewCollection.vue";

const props = defineProps({
	currentCollection: {type: Object},
	collections: {type: Object, default: {"name":"Personal","short_name":"personal","slides_count":0} },
	tags: {type: Object},
	auth: {type: Object},
	pendingSlideCount: {type: Number}
});


const authComplete = ref(false);
const authValid = ref(false);


onMounted(() => {
	if(props.auth.user?.hasGAuth && props.auth.user?.isGAuthValid) authComplete.value = true;
	if(props.auth.user) authValid.value = props.auth.user.isGAuthValid;
});



// --------- Elements to sync back to parent -----//
const searchQuery = defineModel('search');
const chartSizing = defineModel('slideSize');
const selectedTags = defineModel('selectedTags');
const tagMatchAsOR = defineModel('tagMatchAsOR');
// ------- emit an event back to parent to open slide processing window ----//

const emit = defineEmits(['openProcessPending'])
function selectTag(tagName) {

	let index = selectedTags.value.indexOf(tagName);
	if (index === -1) {
		selectedTags.value.push(tagName);
	} else {
		selectedTags.value.splice(index, 1);
	}

}

// -------- New Collection ------- //
const newCollectionDuplicateWarning = ref(false);
const form = useForm({
	newCollectionName: '',
});


const collectionDropdownOpen = ref(false);
const newCollectionModalOpen = ref(false);


function addCollection() {

	if(!form.processing) {
		form.post('/collection', {
			onError: () => {
				newCollectionDuplicateWarning.value = true
				form.newCollectionName = 'Duplicate collection name!';
				setTimeout(() => {
					newCollectionDuplicateWarning.value = false;
					form.newCollectionName = '';
				}, 3000)
			},
			onSuccess: () => {
				document.activeElement.blur();
				form.newCollectionName = '';
			}
		});
	}
}

// ------ Store chartSizing in localStorage ----//

// Retrieve the value from localStorage on component mount
onMounted(() => {
	const storedValue = localStorage.getItem('chartSizing')
	if (storedValue !== null) {
		chartSizing.value = parseInt(storedValue, 10)
	}
})

// Save the value to localStorage when it changes
const saveToLocalStorage = () => {
	localStorage.setItem('chartSizing', chartSizing.value)
}



</script>